import { getWorkspacesByUserId } from '@common/modules/workspaces/stores/workspaces.actions'
import type { Workspace } from '@common/modules/workspaces/types'

import { loadWorkspaceFromStore } from './loadWorkspaceFromStore'

export async function waitForWorkspaceInStore(maxAttempts: number, delayMs: number): Promise<Workspace | null> {
  for (let attempt = 0; attempt < maxAttempts; attempt += 1) {
    const workspace = loadWorkspaceFromStore()
    if (workspace) {
      return workspace
    }

    await getWorkspacesByUserId({ force: true })

    const refreshedWorkspace = loadWorkspaceFromStore()
    if (refreshedWorkspace) {
      return refreshedWorkspace
    }

    if (attempt < maxAttempts - 1) {
      await new Promise((resolve) => setTimeout(resolve, delayMs))
    }
  }

  return null
}
